<template>
    <div class="feedbackSuccess">
        <div class="successImg">
            <img src="../../../images/sucessDialog.png" alt="">
        </div>
        <div class="title">
            <span>
                意见已经提交
            </span>
        </div>
        <div class="descript">
            <span>
                感谢您对住逻辑工作台的支持，我们会尽快查看您的反馈意见
                意见一经采纳将获得10个恐龙蛋作为奖励
            </span>
        </div>
        <div class="feedbackSuccessButton">
            <router-link :to="{path: '/'}"><button class="f1">返回首页</button></router-link>
            <router-link :to="{name: 'myFeedback'}"><button class="f2">继续提建议</button></router-link>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {}
        }
    }
</script>

<style scoped type="text/scss" lang="scss">
    .feedbackSuccess{
        width: 1200px;
        height: 742px;
        background: #fff;
        margin: 0 auto;
        margin-top: 36px;
        text-align: center;
        .successImg{
            width: 100%;
            text-align: center;
            img{
                display: inline-block;
                width: 102px;
                height: 102px;
                margin-top: 113px;
            }
        }
        .title{
            width: 100%;
            margin-top: 24px;
            text-align: center;
            span{
                font-size: 20px;
                color: #353838;
            }
        }
        .descript{
            width: 100%;
            margin-top: 22px;
            text-align: center;
            span{
                display: inline-block;
                width: 383px;
                text-align: center;
                font-size: 14px;
                color: #6C6F70;
            }
        }
        .feedbackSuccessButton{
            width: 100%;
            text-align: center;
            margin-top: 32px;
            button{
                width: 120px;
                height: 40px;
                text-align: center;
                line-height: 35px;
                border: 2px solid #308697;
                border-radius: 4px;
                &:hover{
                    opacity: 0.8;
                }
            }
            button.f1{
                font-size: 14px;
                color: #308697;
                background: #FFFFFF;
            }
            button.f2{
                color: #FFFFFF;
                font-size: 14px;
                background: #308697;
                margin-left: 10px;
            }
        }
    }
</style>